const FilterList = ({ size = 24, color = "var(--primary-text-color)", className = "", tooltipContent = "", tooltipPosition = "" }) => {
    const tooltipProps = tooltipContent ? {
        'data-tooltip-content': tooltipContent,
        'data-tooltip-position': tooltipPosition
    } : {};

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960"
            fill={color}

            {...tooltipProps}
            className={className}
        >
            <path d="M400-240v-80h160v80H400ZM240-440v-80h480v80H240ZM120-640v-80h720v80H120Z" />
        </svg>
    )
}

export default FilterList; 
